var React = require('react');

function Save (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M288 352a64 64 0 1 1-64-64 64 64 0 0 1 64 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M433.94 129.94l-83.88-83.88A48 48 0 0 0 316.12 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V163.88a48 48 0 0 0-14.06-33.94zM224 416a64 64 0 1 1 64-64 64 64 0 0 1-64 64zm96-204a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12V108a12 12 0 0 1 12-12h228.52a12 12 0 0 1 8.48 3.52l3.48 3.48a12 12 0 0 1 3.52 8.48z","className":"fa-primary","key":2})]);
}

Save.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Save;

Save.default = Save;
